import {fetchWithLogs} from '@web-landing/utils/fetch';

export async function fetchSuggestion(
  query: string,
  requestUrl: string | undefined,
) {
  const url = new URL(`${requestUrl}/search/suggest?query=${query}`);

  try {
    return await fetchWithLogs(url.toString(), 'json');
  } catch (e) {
    console.error(e);

    return null;
  }
}
